import { createAuthClient } from 'better-auth/react';

/**
 * Anmelden mit Passkey (Audit F13): Das Passkey-Modul (WebAuthn) wird erst beim Klick geladen – es gehört nicht ins
 * Startpaket aller Seiten.
 */
export async function signInWithPasskey() {
  const { passkeyClient } = await import('@better-auth/passkey/client');
  const client = createAuthClient({ basePath: '/api/auth', plugins: [passkeyClient()] });
  return client.signIn.passkey();
}
